import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const Table = ({ className, ...props }) => (
  <table {...props} className={classNames(className, styles['a-table'])} />
)

export default Table
